import moment from "moment";

class DateTime {
  static getCurrentTimeInMillisec() {
    return moment().valueOf();
  }

  static getCurrentTimeInSec() {
    return moment().unix();
  }

  static getCurrentYear() {
    return moment().year();
  }

  static getCurrentMonth() {
    return moment().month() + 1; //NOTE: moment().month() is zero indexed.
  }

  static getMonths() {
    return moment.months();
  }

  static getPerviousTimeInDaysInMillisec(days) {
    return moment().subtract(days, "days").valueOf();
  }

  static getPerviousTimeInDaysInSec(days) {
    return moment().subtract(days, "days").unix();
  }
}

export default DateTime;



// WEBPACK FOOTER //
// ./src/helpers/date-time.js